import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';

const DemurrageDetailsModal = ({ 
    theme, 
    isOpen, 
    onClose, 
    onRemove,
    demurrageData 
}) => {
    if (!isOpen || !demurrageData) return null;

    return (
        <div 
            className="modal-overlay" 
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
            }}
            onClick={onClose}
        >
            <div 
                className="modal-content"
                style={{
                    backgroundColor: theme === 'dark' ? '#2d2d2d' : '#ffffff',
                    color: theme === 'dark' ? '#ffffff' : '#000000',
                    padding: '30px',
                    borderRadius: '12px',
                    border: theme === 'dark' ? '2px solid #ddd' : '2px solid #444',
                    width: '90%',
                    maxWidth: '500px',
                    minHeight: '500px',
                    maxHeight: '60vh',
                    overflowY: 'auto',
                    position: 'relative',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '25px',
                    borderBottom: theme === 'dark' ? '2px solid #555' : '2px solid #eee',
                    paddingBottom: '15px'
                }}>
                    <h3 style={{ 
                        margin: 0, 
                        color: '#d63384',
                        fontSize: '24px',
                        fontWeight: 'bold'
                    }}>
                        Demurrage Details
                    </h3>
                </div>

                {/* Content */}
                <div style={{
                    backgroundColor: theme === 'dark' ? '#1a1a1a' : '#f8f9fa',
                    padding: '20px',
                    borderRadius: '8px',
                    marginBottom: '20px',
                    border: theme === 'dark' ? '1px solid #444' : '1px solid #e9ecef'
                }}>
                    <div style={{ marginBottom: '15px' }}>
                        <strong style={{ color: theme === 'dark' ? '#fff' : '#333' }}>Type:</strong>
                        <div style={{ 
                            marginTop: '5px',
                            padding: '8px 12px',
                            backgroundColor: theme === 'dark' ? '#333' : '#fff',
                            borderRadius: '4px',
                            border: theme === 'dark' ? '1px solid #555' : '1px solid #ddd'
                        }}>
                            {demurrageData.demurrage}
                        </div>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <strong style={{ color: theme === 'dark' ? '#fff' : '#333' }}>Cost:</strong>
                        <div style={{ 
                            marginTop: '5px',
                            padding: '8px 12px',
                            backgroundColor: theme === 'dark' ? '#333' : '#fff',
                            borderRadius: '4px',
                            border: theme === 'dark' ? '1px solid #555' : '1px solid #ddd',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: '#28a745'
                        }}>
                            £{demurrageData.demurrage_cost}
                        </div>
                    </div>

                    <div>
                        <strong style={{ color: theme === 'dark' ? '#fff' : '#333' }}>Reason:</strong>
                        <div style={{ 
                            marginTop: '8px',
                            padding: '12px',
                            backgroundColor: theme === 'dark' ? '#333' : '#fff',
                            borderRadius: '4px',
                            border: theme === 'dark' ? '1px solid #555' : '1px solid #ddd',
                            borderLeft: '4px solid #6c757d',
                            minHeight: '60px',
                            fontStyle: 'italic',
                            lineHeight: '1.5'
                        }}>
                            {demurrageData.demurrage_reason || 'No reason provided'}
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '15px',
                    marginTop: '25px'
                }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: theme === 'dark' ? '#6c757d' : '#6c757d',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#5a6268'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#6c757d'}
                    >
                        Close
                    </button>
                    <button
                        onClick={onRemove}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#dc3545',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#c82333'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#dc3545'}
                    >
                        <FontAwesomeIcon icon={faTrash} style={{ width: '16px' }} />
                        Remove Demurrage
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DemurrageDetailsModal;